import { searchInvestorsRSEDocumnents as investorsRSEDocumnentsMapper } from '../helpers/filters/investors-rse-documents';
import { search } from './search';

export const FILTER_INVESTORS_RSE_DOCUMENTS = 'investors-rse-documents';
export const searchInvestorsRSEDocumnents = search(
  investorsRSEDocumnentsMapper
);
